export const COMMITTEE_TYPES = [
  { value: 'permanent', labelAr: 'دائمة',  labelEn: 'Permanent', labelUr: 'مستقل',    labelFr: 'Permanent',  labelZh: '常设' },
  { value: 'temporary', labelAr: 'مؤقتة',  labelEn: 'Temporary', labelUr: 'عارضی',    labelFr: 'Temporaire', labelZh: '临时' },
];

export const COMMITTEE_MEMBER_ROLES = [
  { value: 'chairman',  labelAr: 'رئيس اللجنة', labelEn: 'Chairman',  labelUr: 'چیئرمین',   labelFr: 'Président',  labelZh: '主席' },
  { value: 'member',    labelAr: 'عضو',           labelEn: 'Member',    labelUr: 'رکن',       labelFr: 'Membre',     labelZh: '成员' },
  { value: 'secretary', labelAr: 'مقرر',          labelEn: 'Secretary', labelUr: 'سیکریٹری',  labelFr: 'Secrétaire', labelZh: '秘书' },
];

export const EMPTY_COMMITTEE_FORM = {
  name: '',
  type: 'permanent',
  description: '',
  createdAt: new Date().toISOString().slice(0, 10),
  branchId: '',
  isActive: true,
  members: [],
};

function _label(obj, lang) {
  if (lang === 'ar') return obj.labelAr;
  if (lang === 'ur') return obj.labelUr || obj.labelEn;
  if (lang === 'fr') return obj.labelFr || obj.labelEn;
  if (lang === 'zh') return obj.labelZh || obj.labelEn;
  return obj.labelEn;
}

export function committeeTypeLabel(type, lang = 'ar') {
  const row = COMMITTEE_TYPES.find((x) => x.value === type) || COMMITTEE_TYPES[0];
  return _label(row, lang);
}

export function committeeMemberRoleLabel(role, lang = 'ar') {
  const row = COMMITTEE_MEMBER_ROLES.find((x) => x.value === role) || COMMITTEE_MEMBER_ROLES[1];
  return _label(row, lang);
}

const DEFAULT_MSG_AR = {
  nameRequired: 'اسم اللجنة مطلوب',
  branchRequired: 'الشركة مطلوبة',
  membersRequired: 'يجب إضافة عضو واحد على الأقل',
  membersInvalid: 'يرجى اختيار أعضاء اللجنة بشكل صحيح',
};

export function validateCommitteeForm(form, messages = {}) {
  const m = { ...DEFAULT_MSG_AR, ...messages };
  const errors = {};
  if (!form.name.trim()) errors.name = m.nameRequired;
  if (!form.branchId) errors.branchId = m.branchRequired;
  if (!Array.isArray(form.members) || form.members.length < 1) errors.members = m.membersRequired;
  if ((form.members || []).some((x) => !x.boardMemberId)) errors.members = m.membersInvalid;
  return errors;
}
